import { Context } from '@nuxt/types'
import Cookies from 'js-cookie'
import { fetchRevision } from '@/store'
import { UNKNOWN_REVISION_ID } from '@/store/apis/FetchRevision'
import { getItem, setItem } from '@/modules/storage/sessionStorage'
import { RouterUtil, paths } from '~/utils/router'

export default ({ app }: Context) => {
  app.router?.beforeEach(async (_, from, next) => {
    // ページ遷移前に行いたい処理

    // 遷移元が学習ビューワーの場合、そのままページ遷移を行う
    if (from.path.includes('/viewer')) {
      next()
      return
    }

    // SessionStorageのリビジョンIDを取得
    const appRevisionId = getItem('CURRENT_REVISION')

    // storeのリビジョンIDを取得
    // 失敗した場合は、unknownが返る
    await fetchRevision.fetchRevision()
    const s3RevisionId = fetchRevision.result.revision

    // リビジョンIDが取得できなかった場合、SessionStorageのリビジョンIDを更新せず、そのままページ遷移を行う
    if (s3RevisionId === UNKNOWN_REVISION_ID) {
      next()
      return
    }

    // SessionStorageのリビジョンIDを更新
    setItem('CURRENT_REVISION', s3RevisionId)

    // appRevisionIdがnullの場合、初回アクセスと判断し、そのままページ遷移を行う
    if (!appRevisionId) {
      next()
      return
    }
    // リビジョンIDが異なる場合、LocalStorageに最新のリビジョンIDを保存し、トップ画面に遷移する
    // リビジョンIDが同じ場合、そのままページ遷移を行う
    if (appRevisionId !== s3RevisionId) {
      setItem('REVISION_UPDATED', 'true')
      // 末尾にスラッシュがなければ、正しくトップ画面に遷移しないため、追加する
      const redirectUrl = new URL(process.env.BASE_URL ?? '', window.location.origin)
      if (!redirectUrl.pathname.endsWith('/')) {
        redirectUrl.pathname += '/'
      }
      window.location.href = redirectUrl.href
      return
    }
    next()
  })

  app.router?.afterEach((to, from) => {
    // ページ遷移ごとに行いたい処理
    try {
      if (to.path !== '/login') {
        // 暗号化された会員番号を取得
        const memNum = Cookies.get('m_token')
        // GTMへ会員番号を送信
        // eslint-disable-next-line camelcase
        app.$gtm.push({ mem_num: memNum })
      }
    } catch {}

    // ブラウザバック抑制
    window.history.pushState(null, '', null)

    // 戻る場合のフラグ取得とクリア
    const isRouteByBack = RouterUtil.isRouteByBack()
    sessionStorage.removeItem(RouterUtil.ROUTE_BY_BACK_FLG_KEY)

    // ログイン、トップの場合、画面遷移の履歴を全て削除する
    if (to.path === '/login' || to.path === '/top' || to.path === '/') {
      RouterUtil.removeAllHistory()
      return
    }

    // NOTE: 特定のページではスタックを積まない
    const exceptionPaths = [
      paths.VIEWER,
      paths.FULL_DIGITAL_TATEGAKI,
      paths.FULL_DIGITAL_YOKOGAKI,
      paths.PREVIEW,
      paths.FULL_DIGITAL_TEISHUTSU_TATEGAKI,
      paths.FULL_DIGITAL_TEISHUTSU_YOKOGAKI,
      paths.TEISHUTSU_PREVIEW,
    ]
    if (exceptionPaths.some(e => to.path.includes(e)) || exceptionPaths.some(e => from.path.includes(e))) {
      return
    }

    // 戻る場合を除き、画面遷移の履歴を積む。
    if (!isRouteByBack) {
      RouterUtil.pushHistory(from)
    }
  })
}
